import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useSettings } from "../lib/settings";
import { waLink, generalMessage } from "../lib/wa";
import { Ph } from "./Reveal";

export default function Footer() {
  const settings = useSettings();
  const wa = waLink(settings, generalMessage());
  return (
    <footer className="border-t border-zinc-800 bg-ink-900/60">
      <div className="wrap grid gap-12 py-16 md:grid-cols-3">
        <div>
          <img
            src="/images/logo.png"
            alt="Putra Bengawan Logistik"
            className="logo-img-footer"
          />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-400">
            Perusahaan transportasi dengan layanan logistik dan pengiriman barang untuk kebutuhan
            bisnis Anda.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold-deep">Navigasi</p>
          <ul className="mt-5 grid grid-cols-2 gap-2 text-sm">
            <li><Link className="text-zinc-400 hover:text-gold-deep transition-colors" to="/">Home</Link></li>
            <li><Link className="text-zinc-400 hover:text-gold-deep transition-colors" to="/tentang">Tentang Kami</Link></li>
            <li><Link className="text-zinc-400 hover:text-gold-deep transition-colors" to="/galeri">Galeri</Link></li>
            <li><Link className="text-zinc-400 hover:text-gold-deep transition-colors" to="/kontak">Kontak</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold-deep">Kontak</p>
          <ul className="mt-5 space-y-3 text-sm text-zinc-400">
            <li>
              <Ph value={settings?.wa_number}>[ Nomor WhatsApp ]</Ph>
              <span className="text-zinc-600"> — WhatsApp</span>
            </li>
            <li>
              <Ph value={settings?.phone}>[ Nomor Telepon ]</Ph>
              <span className="text-zinc-600"> — Telepon</span>
            </li>
            <li>
              <Ph value={settings?.alamat}>[ Alamat Basecamp ]</Ph>
              <span className="text-zinc-600"> — Alamat</span>
            </li>
          </ul>
          {wa && (
            <a
              data-testid="footer-wa-link"
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#1faf54] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#189544] transition-colors"
            >
              <MessageCircle className="h-4 w-4" /> Chat WhatsApp
            </a>
          )}
        </div>
      </div>
      <div className="border-t border-zinc-800/70 py-6">
        <p className="wrap text-xs text-zinc-500">
          © {new Date().getFullYear()} Putra Bengawan Logistik. Seluruh hak cipta.
        </p>
      </div>
    </footer>
  );
}
